import { render, staticRenderFns } from "./the-best-community-facilities-near-new-seaton.vue?vue&type=template&id=21131e17&scoped=true&"
import script from "./the-best-community-facilities-near-new-seaton.vue?vue&type=script&lang=js&"
export * from "./the-best-community-facilities-near-new-seaton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21131e17",
  null
  
)

export default component.exports